export default __webpack_public_path__ + "static/media/12250179_10153156502855824_7238282123599951908_n.fdbadf8c.jpg";